export const selectInAppHelpState = state => state.inAppHelp;